export default __webpack_public_path__ + "static/media/logo.7c4053b0.svg";